import { Application } from "@hotwired/stimulus"

import WizardController from "./wizard_controller"

window.Stimulus = Application.start()
Stimulus.register("wizard", WizardController)